import React, { useEffect } from 'react'; 
import { Link } from "react-router-dom";
import Header from'../Component/Header';  

const ContactUs = () => { 
    useEffect(() => {
        document.title = 'Contact Us - Sacread Heart Kharagpur';  
    }, []);    
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Contact Us</li>
                </ul>
            </div> 
            <div className="innersec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1>Contact Us</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">  
                            <div className="formbox">
                               <div class="formboxleft">
                                     
                                    <div class="addressdesc">
                                        <div class="addressimg"> <i class="bi bi-geo-alt-fill"></i></div>
                                        <Link to="https://maps.app.goo.gl/m167rxuXM5xwjczR6" target="_blank"> 
                                        Sacred Heart Educational Trust School
                                        Kharagpur, West Bengal 721301</Link>
                                    </div>
                                    <div class="addressdesc">
                                        <div class="addressimg"><i class="bi bi-envelope-fill"></i></div>
                                        <Link to="mailto:shhs.kgp@gmail.com"> shhs.kgp@gmail.com</Link>  
                                    </div>
                                        <div class="addressdesc">
                                            <div class="addressimg"><i class="bi bi-telephone-fill"></i></div>
                                            <Link to="tel:03222256266">  03222 256266</Link> 
                                        </div>
                                </div>
                                <div className="formboxright"> 
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14762.283546093071!2d87.324222!3d22.332063!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1d443ee5dd655b%3A0xe547ff8417ec3912!2sSacred%20Heart%20High%20School!5e0!3m2!1sen!2sin!4v1753161238621!5m2!1sen!2sin" width="100%" height="300" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                              </div>
                            </div> 
                        </div>
                    </div> 
                </div>
            </div>
        </>
    );
}

export default ContactUs;
